module.exports = __webpack_public_path__ + "static/Gilroy-Bold-38026626932431fe477ebb1be40350db.woff";